
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zwangerschapscursus/welkom",
      function () {
        return require("private-next-pages/zwangerschapscursus/welkom.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zwangerschapscursus/welkom"])
      });
    }
  